import { isValidGpax } from './gpax';
/* eslint-disable no-useless-escape */
import _ from 'lodash';
import moment from 'moment';

const today = moment().format('YYYY-MM-DD');
const _isValidEmail = (email) =>
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );

export const errorMessages = (errors = {}) =>
  Object.keys(errors)
    .reduce((array, key) => array.concat(errors[key]), [])
    .filter((msg) => msg);

export const validateEmail = (email) => {
  if (!email) return 'จำเป็นต้องระบุอีเมล';
  if (!_isValidEmail(email)) return 'รูปแบบอีเมลไม่ถูกต้อง';
  return null;
};

export const validateMobile = (mobile) => {
  if (!mobile) return 'จำเป็นต้องระบุเบอร์โทรศัพท์มือถือ';
  if (mobile.length !== 10) return 'รูปแบบเบอร์โทรศัพท์มือถือไม่ถูกต้อง';
  return null;
};

export const validateTitle = (title) => {
  if (!title) return 'จำเป็นต้องระบุคำนำหน้าชื่อ';
  if (!['นาย', 'นางสาว'].includes(title)) return 'คำนำหน้าชื่อ เป็นได้แค่ นาย หรือ นางสาว เท่านั้น';
  return null;
};

// citizen_id / gnumber → ชื่อไทยเท่านั้น, passport → อังกฤษเท่านั้น — ช่องชื่อเพิ่มเติมกติกากลับด้าน
// ก-ฺ + เ-๎ = พยัญชนะ/สระ/วรรณยุกต์ครบ แต่ไม่รวมเลขไทย ๐-๙ และ ฿
const NAME_TH_PATTERN = /^[ก-ฺเ-๎\s.\-]+$/;
const NAME_EN_PATTERN = /^[a-zA-Z\s.\-']+$/;
export const NAME_LANG_BY_TYPE = { citizen_id: 'th', gnumber: 'th', passport: 'en' };
export const ALT_NAME_LANG_BY_TYPE = { citizen_id: 'en', gnumber: 'en', passport: 'th' };
const nameLanguageError = (value, lang, fieldLabel) => {
  const _value = value.replace(/​/g, '').trim();
  if (lang === 'th' && !NAME_TH_PATTERN.test(_value)) return `${fieldLabel}ต้องเป็นภาษาไทยเท่านั้น`;
  if (lang === 'en' && !NAME_EN_PATTERN.test(_value)) return `${fieldLabel}ต้องเป็นภาษาอังกฤษเท่านั้น`;
  return null;
};

export const validateFirstName = (firstName, citizenIdType) => {
  if (!firstName) return 'จำเป็นต้องระบุชื่อ';
  return nameLanguageError(firstName, NAME_LANG_BY_TYPE[citizenIdType], 'ชื่อ');
};

export const validateLastName = (lastName, citizenIdType) => {
  if (!lastName) return 'จำเป็นต้องระบุนามสกุล';
  if (lastName === 'ไม่มีนามสกุล') return null;
  return nameLanguageError(lastName, NAME_LANG_BY_TYPE[citizenIdType], 'นามสกุล');
};

// ช่องชื่อ-นามสกุลเพิ่มเติมไม่บังคับกรอก — เช็คภาษาเฉพาะตอนมีค่า
export const validateFirstNameAdditional = (firstNameAdditional, citizenIdType) => {
  if (!firstNameAdditional) return null;
  const label = citizenIdType === 'passport' ? 'ชื่อภาษาไทย' : 'ชื่อภาษาอังกฤษ';
  return nameLanguageError(firstNameAdditional, ALT_NAME_LANG_BY_TYPE[citizenIdType], label);
};

export const validateLastNameAdditional = (lastNameAdditional, citizenIdType) => {
  if (!lastNameAdditional) return null;
  const label = citizenIdType === 'passport' ? 'นามสกุลภาษาไทย' : 'นามสกุลภาษาอังกฤษ';
  return nameLanguageError(lastNameAdditional, ALT_NAME_LANG_BY_TYPE[citizenIdType], label);
};

export const validateBirthDate = (birthDate) => {
  if (!birthDate) return 'จำเป็นต้องระบุวันเกิด';
  return null;
};

export const validateSpecialRequest = (specialRequest, visibility) => {
  if (!visibility) return null;
  if (!specialRequest) return 'จำเป็นต้องระบุความต้องการความช่วยเหลือพิเศษ';
  return null;
};

export const validatePassword = (password) =>
  _.compact([
    !/(?=.{8,})/.test(password) ? 'รหัสผ่านต้องมีจำนวนไม่น้อยกว่า 8 หลัก' : undefined,
    !/(?=.*[A-Z])/.test(password) ? 'รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์ใหญ่ A - Z อย่างน้อย 1 ตัว' : undefined,
    !/(?=.*[a-z])/.test(password) ? 'รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษพิมพ์เล็ก a - z อย่างน้อย 1 ตัว' : undefined,
    !/(?=.*[0-9])/.test(password) ? 'รหัสผ่านต้องมีตัวเลข 0 - 9 อย่างน้อย 1 ตัว' : undefined,
  ]);

export const validateCitizenCardFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปด้านหน้าบัตรประจำตัว';
  return null;
};

export const validateSelfieFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปถ่ายคู่บัตรประจำตัว';
  return null;
};

export const validateSpecialRequestFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปหลักฐานต้องการความช่วยเหลือพิเศษ';
  return null;
}

export const validateTranscriptFrontFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปด้านหน้าใบปพ.1';
  return null;
};

export const validateTranscriptBackFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปด้านหลังใบปพ.1';
  return null;
};

export const validateRAEFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปใบเทียบวุฒิการศึกษา';
  return null;
};

export const validateGPAFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปใบเทียบผลการเรียนเฉลี่ยสะสม (GPAX)';
  return null;
};

export const validateGedFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูป GED Transcript';
  return null;
};

export const validateGedDate = (date) => {
  if (!date) return 'จำเป็นต้องระบุวันที่สอบ';
  if (date.localeCompare(today) === 1) return 'ไม่อนุญาตให้กรอกวันที่ในอนาคต';
  return null;
};

export const validateVnetFile = (file) => {
  if (!file) return 'จำเป็นต้องอัปโหลดรูปใบคะแนน V-NET';
  return null;
};

export const validateSchoolName = (schoolName) => {
  if (!schoolName) return 'จำเป็นต้องระบุชื่อโรงเรียน';
  return null;
};

// validatePostalCode / validateProvinceId / validateDistrictId /
// validateSubDistrictId moved to validations.address.js — they pull the
// large district/sub-district JSONs, which must stay out of the main bundle.

export const validateAddress = (address) => {
  if (!address) return 'จำเป็นต้องระบุที่อยู่';
  return null;
};

// กติกา sync กับ BE checkGpax (helpers/validation.js) — ส่งเป็น String ทศนิยม 2 ตำแหน่งเสมอ
export const validateGpax = (gpax, fieldName) => {
  if (gpax == null || gpax === '') return `จำเป็นต้องระบุ ${fieldName}`;
  if (!isValidGpax(gpax)) return `${fieldName} ต้องเป็นตัวเลขระหว่าง 0–4`;
  if (!/^\d+(\.\d{1,2})?$/.test(`${gpax}`.trim())) return `${fieldName} ต้องเป็นตัวเลขทศนิยมไม่เกิน 2 ตำแหน่ง`;
  return null;
};

export const validateWeight = (weight, nullable) => {
  if (!nullable && !weight) return 'จำเป็นต้องระบุน้ำหนัก';
  if (!nullable && weight < 20) return 'น้ำหนักต้องมีค่าไม่น้อยกว่า 20 กิโลกรัม';
  if (!nullable && weight > 200) return 'น้ำหนักต้องมีค่าไม่มากกว่า 200 กิโลกรัม';
  return null;
};

export const validateHeight = (height, nullable) => {
  if (!nullable && !height) return 'จำเป็นต้องระบุส่วนสูง';
  if (!nullable && height < 100) return 'ส่วนสูงต้องมีค่าไม่น้อยกว่า 100 เซนติเมตร';
  if (!nullable && height > 250) return 'ส่วนสูงต้องมีค่าไม่มากกว่า 250 เซนติเมตร';
  return null;
};

const _characters = ['่', '้', '๊', '๋', '็', '์', 'ํ', 'ิ', 'ี', 'ื'];
export const notAllowed = (fieldType, _value = '') => {
  const value = `${_value || ''}`;
  switch (fieldType) {
    case 'email':
      if (/[ก-๙]/g.test(value)) return true;
      if (value.includes(' ')) return true;
      return false;
    case 'mobile':
      if (value.length > 10) return true;
      if (value && isNaN(value)) return true;
      if (value < 0) return true;
      return false;
    case 'postalCode':
      if (value.includes(' ')) return true;
      if (value.length > 5) return true;
      if (value === 0) return true;
      return false;
    case 'postalCodeEn':
      if (value.includes(' ')) return true;
      if (value.length > 10) return true;
      if (value === 0) return true;
      return false;
    case 'textTH':
      if (_characters.some((_char) => value.startsWith(_char) || value.includes(`${_char}${_char}`))) {
        return true;
      }
      return false;
    // whitelist ให้ตรงกับ NAME_TH/EN_PATTERN (+ZWSP ที่ค่อย strip ตอน submit) — blocklist เคยปล่อยตัวเลขหลุด
    case 'nameTH':
      if (/[^ก-ฺเ-๎\s.\-​]/.test(value)) return true;
      return false;
    case 'nameEN':
      if (/[^a-zA-Z\s.\-'​]/.test(value)) return true;
      return false;
    case 'number':
      if (value && isNaN(value)) return true;
      if (value < 0) return true;
      return false;
    case 'gpax':
      if (value && isNaN(value)) return true;
      if (value < 0) return true;
      if (value > 4) return true;
      if (value.length > 4) return true;
      return false;
    case 'weight':
      if (value && isNaN(value)) return true;
      if (value.includes(' ')) return true;
      if (value < 0) return true;
      if (value > 200) return true;
      return false;
    case 'height':
      if (value && isNaN(value)) return true;
      if (value.includes(' ')) return true;
      if (value < 0) return true;
      if (value > 250) return true;
      return false;
    default:
      return false;
  }
};
